export const LOAD_TRANSACTIONS =
  'app/TransactionsListContainer/LOAD_TRANSACTIONS';
export const LOAD_TRANSACTIONS_SUCCESS =
  'app/TransactionsListContainer/LOAD_TRANSACTIONS_SUCCESS';
export const LOAD_TRANSACTIONS_ERROR =
  'app/TransactionsListContainer/LOAD_TRANSACTIONS_ERROR';
export const DOWNLOAD_CAMT = 'app/TransactionsListContainer/DOWNLOAD_CAMT';
